/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Smartbot-LA / Leninsoft
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from "./state"
import getters from "./getters"
import mutations from "./mutations"
import actions from "./actions"
import auth from './auth/index'
import user from './user/index'
import lists from './lists/index'
import menu from './menu/index'
import rol from './rol/index'
import rolesbymenu from './rolesbymenu/index'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    user,
    lists,
    menu,
    rol,
    rolesbymenu,
  },
  getters,
  mutations,
  state,
  actions,
  strict: process.env.NODE_ENV !== 'production'
})
